module.exports = __webpack_public_path__ + "img/matiere.a906cd2a.png";